import Accordion from 'react-bootstrap/Accordion';
import SportCode from 'components/common/SportCode'
import MirsTable from 'components/general/table/Table.js';
import Label from "components/general/Label";
import { useMemo } from 'react';
import { findArray } from 'helpers/utils';
import Competitor from "components/presentation/Competitor";
import { useViewport } from 'components/general/useViewPort'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { VbvTeamStatistics, VbvTeamStatisticsSM } from './VbvTeamStatistics';


const getPeriodOrder = (periodsOrder, period) => {
    return periodsOrder?.find(i => i.period === period)?.order;
}

const RenderPeriods = ({ data, statsTOT, statsSet, periods, periodsOrder }) => {
    const { breakPoint } = useViewport();
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    const { mirs_discipline } = useUrlFriendlyToParameters()
    return periods?.map(item => {
        let currPeriod = item.p_code
        let teamStatistics;
        if (currPeriod === 'TOT') {
            teamStatistics = isMobile
                ? <VbvTeamStatisticsSM data={data?.results} stats={statsTOT} currPeriod={currPeriod} />
                : <VbvTeamStatistics data={data?.results} stats={statsTOT} currPeriod={currPeriod} />
        } else {
            teamStatistics = isMobile
                ? <VbvTeamStatisticsSM data={data?.results} stats={statsSet} currPeriod={currPeriod} />
                : <VbvTeamStatistics data={data?.results} stats={statsSet} currPeriod={currPeriod} />
        }
        return (
            <Accordion.Item id={`mirs-accordion-item-${item.p_code}`} eventKey={item.p_code} key={item.p_code}>
                <Accordion.Header><SportCode discipline={mirs_discipline} entity='@Period' code={item.p_code} /></Accordion.Header>
                <Accordion.Body>
                    {teamStatistics}
                </Accordion.Body>
            </Accordion.Item>
        )
    }
    )
}



function VbvTeamStats({ data, periodsOrder }) {
    const handleClick = (e) => {
        // console.log(e);
    }

    const statsTOT = [
        { code: 'DIG' },
        { code: 'TOT_TEAM', bold: 'fw-bold' },
        { code: 'OPP_ERR', bold: 'fw-bold' },
        { code: 'BLC', bold: 'fw-bold' },
        { code: 'ATC', component: 'type9', header: 'ATC_TOTAL' },
        { code: 'PLAY', component: 'type10', paint: 'ATC', header: 'ATC_PLAY' },
        { code: 'FLT', component: 'type10', paint: 'ATC', header: 'ATC_FLT' },
        { code: 'ATC', bold: 'fw-bold' },
        { code: 'SPEED', component: 'type11', paint: 'SRV', label: 'LabelKMH' },
        { code: 'SRV', component: 'type9' },
        { code: 'PLAY', component: 'type10', paint: 'SRV' },
        { code: 'FLT', component: 'type10', paint: 'SRV' },
        { code: 'ACE', component: 'type10', paint: 'SRV', bold: 'fw-bold' }

    ]

    //Added because the SCR doesn't have value and attempt for single sets. Might need to be reviewed
    const statsSet = [
        { code: 'DIG' },
        { code: 'TOT_TEAM', bold: 'fw-bold' },
        { code: 'OPP_ERR', bold: 'fw-bold' },
        { code: 'BLC', bold: 'fw-bold' },
        { code: 'ATC', component: 'type9', header: 'ATC_TOTAL' },
        { code: 'PLAY', component: 'type10', paint: 'ATC', header: 'ATC_PLAY' },
        { code: 'FLT', component: 'type10', paint: 'ATC', header: 'ATC_FLT' },
        { code: 'ATC', bold: 'fw-bold' },
        { code: 'SPEED', component: 'type11', paint: 'SRV', label: 'LabelKMH' },
        { code: 'SRV', component: 'type9' },
        { code: 'PLAY', component: 'type10', paint: 'SRV' },
        { code: 'FLT', component: 'type10', paint: 'SRV' },
        { code: 'ACE', component: 'type10', paint: 'SRV', bold: 'fw-bold' }
    ]


    let periods = data?.results?.periods
    periods?.sort((a, b) => getPeriodOrder(periodsOrder, b.p_code) - getPeriodOrder(periodsOrder, a.p_code));

    return (<>
        <Accordion defaultActiveKey={periods[0].p_code} onClick={(e) => handleClick(e)}>
            <RenderPeriods data={data} statsTOT={statsTOT} statsSet={statsSet} periods={periods} periodsOrder={periodsOrder} />
        </Accordion>
    </>);
}

export default VbvTeamStats;